import MobileLabelLine from 'components/MobileWhiteCardLine'
import type { DomainType } from 'features/domains/types'
import {
  TransferDealerEmailCell,
  TransferDealerNameCell,
  TransferDealerSelectedCell,
} from '.'
import {
  TransferLicenseMobileContainer,
  TransferLicenseNameRow,
} from '../styles'

interface TransferLicenseMobileProps {
  values: Record<string, any>
  original: DomainType
  targetDealer: DomainType | null
}

/**
 * @todo localization
 */

function TransferLicenseMobile({
  original,
  targetDealer,
}: TransferLicenseMobileProps) {
  return (
    <TransferLicenseMobileContainer
      $isSelected={original.id === targetDealer?.id}
    >
      <TransferLicenseNameRow>
        <TransferDealerNameCell dealer={original} />
        <TransferDealerSelectedCell
          dealer={original}
          targetDealer={targetDealer}
        />
      </TransferLicenseNameRow>
      <MobileLabelLine label="Phone" value={original.phone} />
      <MobileLabelLine
        label="Email"
        value={<TransferDealerEmailCell email={original?.email} />}
      />
    </TransferLicenseMobileContainer>
  )
}

export default TransferLicenseMobile
